module.exports = __webpack_public_path__ + "img/Guirlandes_de_mariage.c40b870.jpg";